export function formatDuration(sec) {
    const second = Math.round(sec % 60);
    const minute = Math.floor(sec / 60);
    return `${minute <= 9 ? '0' : ''}${minute}:${second <= 9 ? '0' : ''}${second}`;
}

